export function addClassList(element, classes) {
  if (typeof classes === 'string') {
    return element.classList.add(classes);
  }
  return element.classList.add(...classes);
}
